import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SelectConfig } from '../../entities/select-config';
import { HttpService } from '../../services/http/http-service.service';
import { CommonService } from '../../services/common/common.service';
import { isThisSecond } from 'date-fns';

@Component({
  selector: 'app-s-selector',
  templateUrl: './s-selector.component.html',
  styleUrls: ['./s-selector.component.less'],
})
export class SSelectorComponent implements OnInit {
  @Input() options: SelectConfig;
  @Output() optionChange: EventEmitter<any> = new EventEmitter();
  style = {
    maxHeight: '150px',
    overflow: 'auto'
  };

  constructor(
    private httpService: HttpService,
    private commonService: CommonService
  ) {}
  loading = false;
  pramas: any = { page: 1, pageSize: 20 };
  compareFn = (o1: any, o2: any) => o1 && o2 ? o1.value === o2.value : o1 === o2;

  /** 默认请求数据 */
  ngOnInit(): void {
    if (this.options) {
      this.initOptions();
      if (this.options.url && this.options.defaultLoad) {
        this.initParams();
        this.options.data = [];
        this.getOptionsData();
      }
    }
  }

  modelChange(e) {
    this.optionChange.emit(e);
  }

  getStepMess() {
  }

  /** 下拉框展开时获取数据 */
  openChange(e) {
    // if (e) {
    //   if (this.options.url && !this.options.defaultLoad && !this.options.parent) {
    //     this.initParams();
    //     this.options.data = [];
    //     this.getOptionsData();
    //   }
    // }
  }

  /** 分页下拉加载更多 */
  loadMore() {
    this.initParams();
    if (!this.options.isPage) {
      return;
    }
    this.pramas.page += 1;
    this.getOptionsData();
  }

  initParams() {
    const params = {};
    if (this.options.params && Object.keys(this.options.params).length) {
      for (const key in this.options.params) {
        if (this.options.params.hasOwnProperty(key)) {
          if (this.options.params[key]) {
            Object.defineProperty(params, key, {
              value: this.options[key],
              enumerable: true,
              writable: true,
            });
          }
        }
      }
    }
    if (this.options.isPage) {
      Object.defineProperties(params, {
        page: {
          value: this.pramas.page ? this.pramas.page : 1,
          enumerable: true,
          writable: true,
        },
        pageSize: {
          value: this.options.pageSize ? this.options.pageSize : 20,
          enumerable: true,
          writable: true,
        },
      });
    }
    this.pramas = params;
  }

  getOptionsData() {
    this.options.data = [];
    this.loading = true;
    this.httpService.httpGet(this.options.url, this.pramas).subscribe(res => {
      if (res.code === 1) {
        this.loading = false;
        this.options.data = res.data;
      }
    });
  }

  renderOptionList(data) {
    if (this.options.url) {
      if (data.length) {
        this.resetOPtionData(data);
      }
      this.options.data = [...this.options.data, ...data];
      if (this.options.defaultLoad && this.options.isSelectedFirst) {
        if (this.options.mode === 'default') {
          this.options.selectedValue = {
            label: this.options.data[0].label,
            value: this.options.data[0].value,
            key: this.options.key ? this.options.key : null,
            children: this.options.children ? this.options.children : null,
            parent: this.options.parent ? this.options.parent : null
          };
        } else {
          this.options.selectedValue = [
            {
              label: this.options.data[0].label,
              value: this.options.data[0].value,
              showStep: this.options.data[0].showStep
            },
          ];
        }
      }
    } else {
      if (this.options.data.length) {
        this.resetOPtionData(data);
        this.options.data = data;
      }
    }
  }

  resetOPtionData(data, name?, value?) {
    data.forEach((item) => {
      if (name) {
        item.label = item[name];
      }
      if (value) {
        item.value = item[value];
      }
      item.key = this.options.key ? this.options.key : null;
      item.children = this.options.children ? this.options.children : null;
      item.parent = this.options.parent ? this.options.parent : null;
    });
    this.options.data = data;
  }

  initOptions() {
    this.options.allowClear = this.commonService.isNull(this.options.allowClear)
      ? this.options.allowClear
      : true;
    this.options.showSearch = this.commonService.isNull(this.options.showSearch)
      ? this.options.showSearch
      : true;
    this.options.disabled = this.commonService.isNull(this.options.disabled)
      ? this.options.disabled
      : false;
    this.options.isPage = this.commonService.isNull(this.options.isPage)
      ? this.options.isPage
      : false;
    this.options.defaultLoad = this.commonService.isNull(
      this.options.defaultLoad
    )
      ? this.options.defaultLoad
      : false;
    this.options.selectedValue = this.commonService.isNull(
      this.options.selectedValue
    )
      ? this.options.selectedValue
      : null;
    this.options.isSelectedFirst = this.commonService.isNull(
      this.options.isSelectedFirst
    )
      ? this.options.isSelectedFirst
      : false;
    this.options.params = this.commonService.isNull(
      this.options.params
    )
      ? this.options.params
      : {};
    if (!this.options.mode || this.options.mode === 'default') {
      this.options.mode = 'default';
      // this.options.selectedValue = {};
    } else if (
      this.options.mode === 'tags' ||
      this.options.mode === 'multiple'
    ) {
      // this.options.selectedValue = [];
    }
  }
}
